module.exports = __webpack_public_path__ + "img/BlueMetallic_B.50295532.png";